import { IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useState } from 'react';
const MuiPasswordInput = (props) => {
    const [passVisible, setPassVisible] = useState(false)
    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }
    return (
        <TextField
            required
            margin="normal"
            fullWidth
            type={passVisible ? 'text' : 'password'}
            autoComplete="current-password"
            helperText={props.passwordError && 'Password is required'}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                                setPassVisible(!passVisible)
                            }
                            onMouseDown={
                                handleMouseDownPassword
                            }>
                            {passVisible ? (
                                <Visibility />
                            ) : (
                                <VisibilityOff />
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    )
}
export default MuiPasswordInput